export const PresenceFilterVariables = { filters: 'PresenceFilters' };
